
import { mkFreeToSpend } from 'data/freeToSpend/freeToSpendTypes';


export function transformResponseToFreeToSpend(response) {
  return response.data.resources.map((fts) => mkFreeToSpend(fts));
}

